<template>
    <ui-card-base with-border>
        <div class="page-cabinet-deals-secondary-item">
            <div class="page-cabinet-deals-secondary-item__headline">
                <div class="page-cabinet-deals-secondary-item__headline-image">
                    <common-image
                        v-bind:image="image"
                        v-bind:href="item.estate.url"
                    />
                </div>
                <div class="page-cabinet-deals-secondary-item__headline-info">
                    <div class="page-cabinet-deals-secondary-item__headline-info-estate"
                        v-text="item.estate.title"
                    />
                    <div class="page-cabinet-deals-secondary-item__headline-info-top-document"
                         v-if="document"
                    >
                        <ui-trigger
                            v-on:click="openDocumentModal"
                            text="Документы"
                            icon-left="legal-entity-i"
                            variant="dark"
                            is-underline-inverted
                            is-uppercase
                        />
                    </div>
                </div>
            </div>

            <div class="page-cabinet-deals-secondary-item__document" v-if="document">
                <ui-trigger
                    v-on:click="openDocumentModal"
                    text="Документы"
                    icon-left="legal-entity-i"
                    variant="dark"
                    is-underline-inverted
                    is-uppercase
                />
            </div>

            <div style="height: 8px"/>

            <template v-if="statusTheme">
                <div style="padding-left: 70px">
                    <ui-label
                        v-bind:title="item.statusTitle"
                        v-bind:theme="statusTheme"
                        is-uppercase
                    />
                </div>
            </template>
            <template v-else>
                <ui-process :steps="steps" />
            </template>

            <div class="page-cabinet-deals-secondary-item__botline">
                <div class="page-cabinet-deals-secondary-item__botline-stats">
                    <div class="page-cabinet-deals-secondary-item__botline-stats-item"
                        v-for="(stat, i) in stats"
                        v-bind:key="i"
                        >
                        <div class="page-cabinet-deals-secondary-item__botline-stats-item-title"
                            v-text="stat.title"
                        />
                        <div class="page-cabinet-deals-secondary-item__botline-stats-item-value"
                            v-text="stat.value"
                        />
                    </div>
                </div>
                <div class="page-cabinet-deals-secondary-item__botline-actions"
                    v-if="isSignAvailable || isEditAvailable || isStatusFormRequired"
                    >
                    <div
                        class="page-cabinet-deals-item__botline-actions-item"
                        v-if="isCancelAvailable"
                    >
                        <ui-button
                            v-on:click="cancelHandler"
                            theme="secondary-1"
                            is-uppercase
                        >
                            Отменить
                        </ui-button>
                    </div>
                    <div class="page-cabinet-deals-secondary-item__botline-actions-item"
                        v-if="isEditAvailable"
                        >
                        <ui-button
                            theme="primary"
                            v-on:click="editHandler"
                            >
                            Редактировать
                        </ui-button>
                    </div>
                    <div class="page-cabinet-deals-secondary-item__botline-actions-item"
                        v-if="isStatusFormRequired"
                        >
                        <ui-button
                            theme="primary"
                            v-on:click="openStatusModal"
                            >
                            Открыть счёт
                        </ui-button>
                    </div>
                    <div class="page-cabinet-deals-secondary-item__botline-actions-item"
                        v-else-if="isSignAvailable"
                        >
                        <ui-button
                            theme="primary"
                            v-on:click="signHandler"
                            >
                            Подписать
                        </ui-button>
                    </div>
                </div>
            </div>
        </div>
    </ui-card-base>
</template>

<script>
import utils from '~/utils';

export default {
    name: 'page-cabinet-deals-secondary-item',
    props: {
        item: {
            type: Object,
        },
    },
    computed: {
        image() {
            return utils.common.injectResize(this.item.estate.image, '134x134');
        },
        stats() {
            const result = [
                { title: 'Дата', value: this.item.dateFormatted },
                { title: 'Тип заявки', value: this.item.typeTitle },
                { title: 'Цена акции', value: this.item.priceFormatted },
                { title: 'Кол-во акций', value: this.item.amountFormatted },
            ];
            if (this.item.commission) {
                // result.push({ title: 'Комиссия', value: this.item.commissionFormatted });
                result.push({ title: 'Сумма', value: this.item.sumWithCommissionFormatted });
                // result.push({ title: 'Сумма', value: this.item.sumFormatted });
                // result.push({ title: 'Сумма с комиссией', value: this.item.sumWithCommissionFormatted });
            } else {
                result.push({ title: 'Сумма', value: this.item.sumFormatted });
            }
            return result;
        },
        isStatusFormRequired() {
            return this.item?.isStatusFormRequired && this.item.type === 'buy';
        },
        isSignAvailable() {
            return this.item.deal?.status === 'processing' && this.item.status === 'wait_sign';
        },
        isEditAvailable() {
            return this.item.status === 'active';
        },
        isCancelAvailable() {
            return this.item.status === 'active' && !this.item.counterOrder;
        },
        document() {
            if (this.item.status === 'canceled') {
                return null;
            }
            return this.item.document;
        },
        statusTheme() {
            // if (this.isStatusFormRequired) {
            //     return 'warning';
            // }
            if (this.item.status === 'canceled') {
                return 'negative';
            }
            if (this.item.status === 'completed') {
                return 'positive';
            }
            return null;
        },
        steps() {
            if (this.item.type === 'sale') {
                return [
                    {
                        title: 'Заявка на продажу размещена',
                        icon: 'spinner',
                        description: 'Дождитесь пока покупатель примет заявку.',
                        isCurrent: this.item.status === 'active',
                    },
                    {
                        title: 'Подписание документов',
                        icon: 'pen',
                        description: 'Необходимо подписать договор купли-продажи акций, а если договор уже подписан, дождитесь пока подпишет покупатель.',
                        isCurrent: this.item.status === 'wait_sign' || this.item.counterOrder?.status === 'wait_sign',
                    },
                    {
                        title: 'Перевод акций',
                        icon: 'receipt',
                        description: 'Переведите акции на счет покупателя в личном кабинете реестродержателя «Статус». Сделка будет  проведена после обработки заявки реестродержателем «Статус». Обычно этот процесс занимает до 5 рабочих дней.',
                        isCurrent: this.item.status === 'signed' && this.item.isCounterOrderSigned,
                        instructionUrl: require('/static/docs/guide_sell.pdf'),
                    },
                    {
                        title: 'Проведена',
                        icon: 'check-thin',
                        description: '',
                        isCurrent: this.item.status === 'completed',
                    },
                ];
            }
            return [
                {
                    title: 'Заявка на покупку размещена',
                    icon: 'spinner',
                    description: 'Дождитесь пока продавец примет заявку. Пока ожидаете принятия заявки необходимо открыть счет в реестродержателе «Статус», если ранее данный счет не был открыт. Обратите внимание, что для каждого объекта необходимо открывать отдельный счет.',
                    isCurrent: this.item.status === 'active',
                    instructionUrl: require('/static/docs/guide_buy.pdf'),
                },
                {
                    title: 'Подписание документов',
                    icon: 'pen',
                    description: 'Необходимо подписать договор купли-продажи акций, а если договор уже подписан, дождитесь пока подпишет продавец. Для перевода акций необходимо открыть счет в реестродержателе «Статус», если ранее данный счет не был открыт. Обратите внимание, что для каждого объекта необходимо открывать отдельный счет.',
                    isCurrent: this.item.status === 'wait_sign' || this.item.counterOrder?.status === 'wait_sign',
                    instructionUrl: require('/static/docs/guide_buy.pdf'),
                },
                {
                    title: 'Начисление акций',
                    icon: 'receipt',
                    description: 'Дождитесь пока продавец переведет акции на ваш счет в реестродержателе «Статус». Обычно этот процесс занимает до 10 рабочих дней. Акции появятся в личном кабинете после их начисления со стороны реестродержателя «Статус».',
                    isCurrent: this.item.status === 'signed' && this.item.isCounterOrderSigned,
                },
                {
                    title: 'Проведена',
                    icon: 'check-thin',
                    description: '',
                    isCurrent: this.item.status === 'completed',
                },
            ];
        },
    },
    methods: {
        openStatusModal() {
            this.$store.commit('modals/push', {
                name: 'status-form',
                props: {
                    estate: this.item.estate,
                },
            });
        },
        signHandler() {
            this.$store.commit('modals/push', {
                name: 'market-application-confirm',
                props: {
                    deal: this.item,
                },
            });
        },
        cancelHandler() {
            this.$store.commit('modals/push', {
                name: 'generic',
                props: {
                    title: 'Отмена заявки',
                    text: `Подтвердите отмену заявки на ${this.item.type === 'buy' ? 'покупку' : 'продажу'} акций в объекте ${this.item.estate.title} на сумму ${this.item.sumFormatted}`,
                    buttons: [
                        {
                            text: 'Подтвердить',
                            callback: () => {
                                this.$store.commit('modals/pop');
                                this.$store.dispatch('market/cancelOrder', {
                                    id: this.item.id,
                                    onSuccess: () => {
                                        this.$store.commit('modals/pop');
                                        this.$store.commit('modals/push', {
                                            name: 'generic',
                                            props: {
                                                title: 'Заявка успешно отменена',
                                            },
                                        });
                                    },
                                });
                            },
                        },
                    ],
                },
            });
        },
        openDocumentModal() {
            this.$store.commit('modals/push', {
                name: 'download-docs',
                props: {
                    title: this.item?.estate?.title || 'Документы для скачивания',
                    items: [
                        {
                            id: this.document.id,
                            title: 'Договор купли-продажи',
                            url: this.document.url,
                            created: this.item.date,
                        },
                    ],
                },
            });
        },
        editHandler() {
            this.$store.commit('modals/push', {
                name: 'market-application-create',
                props: {
                    orderId: this.item.id,
                    givenShareId: this.item.share.id,
                    givenType: this.item.type,
                    givenAmountLimit: this.item.amount,
                    givenPrice: this.item.price,
                    givenIsPackageValue: this.item.isPackage,
                    isLocked: true,
                    // isLocked: !this.getOrdersResult,
                    // availableShares: this.getOrdersResult ? this.getOrdersResult.map(x => x.share.id) : null,
                    mode: 'edit',
                },
            });
        },
    },
};
</script>

<style scoped lang="less">
@import '~theme';

.page-cabinet-deals-secondary-item {
    padding: 8px;
    &__headline {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        &-image {
            flex: 0 0 auto;
            width: 54px;
            height: 54px;
            margin-right: 16px;

            @media @media-sm-down {
                width: 48px;
                height: 48px;
                margin-right: 12px;
            }
        }
        &-info {
            flex: 1 1 auto;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            gap: 8px;
            &-top {
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
                margin-bottom: 8px;
                &-status {
                    flex: 0 1 auto;
                }
                &-document {
                    .typography-caption();

                    flex: 0 1 auto;
                }
            }
            &-estate {
                .typography-medium();
            }
        }
    }
    &__botline {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-top: 16px;
        border-top: 1px solid @color-gray-light;
        padding-top: 24px;
        &-stats {
            flex: 0 0 auto;
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
            gap: 8px;
            width: 100%;
            max-width: 569px;

            &-item {
                .typography-body();

                flex: 0 0 auto;

                &-title {
                    margin-bottom: 8px;

                    color: @color-gray-main;
                }
            }
        }
        &-actions {
            display: flex;
            align-items: center;
            justify-content: flex-end;
            gap: 24px;
            &-item {
                flex: 0 0 auto;
                width: fit-content;
            }
        }
    }
    &__document {
        display: none;
        width: 120px;
        margin-left: 70px;
        padding: 8px 0;
    }
    @media @media-xl-down {
        padding: 0;
        &__headline {
            &-info {
                justify-content: flex-start;
                &-top {
                    margin-bottom: 4px;
                    &-document {
                        display: none;
                    }
                }
                &-estate {
                    .typography-heading();
                }
            }
        }
        &__botline {
            flex-direction: column;
            align-items: flex-start;
            padding-top: 16px;

            &-actions {
                flex-direction: column-reverse;
                gap: 16px;
                padding-top: 24px;
                width: 100%;
                justify-content: center;

                &-accept {
                    width: 100%;
                    max-width: 280px;
                    margin: 0 auto 24px;
                }
                &-cancel {
                    margin: 0 auto;
                    width: fit-content;
                }
            }
        }
        &__document {
            .typography-caption();

            display: block;
            width: fit-content;
        }
    }
}
</style>
